<template>
    <Accordion :open="true" role="group" class="mb-4 pb-3 border-b last:border-b-0">
        <template v-slot:title>
            <h3 class="!text-base !font-bold !pointer-events-none !leading-5 !m-0 !mb-2">{{ filter.label }}</h3>
        </template>
        <template v-slot:content>
            <ul class="!list-none !m-0 !p-0 !ps-0">
                <!-- loop through filters that are not disabled -->
                <li class="!mb-0 inline-flex hover:cursor-pointer w-full"
                    :data-attr-id="attribute.id"
                    v-for="attribute in filter.attributes"
                    v-if="!attribute.is_disabled">

                    <input :id="`filter_attr_${attribute.id}`"
                           type="checkbox"
                           :checked="!attribute.is_disabled && attribute.is_active"
                           class="w-4 h-4 accent-gdc-red-600 !border-gdc-gray-900 !rounded !focus:ring-0 hover:cursor-pointer"
                           @click="toggleFilter(attribute)"
                    />

                    <label :for="`filter_attr_${attribute.id}`"
                           class="pl-1 text-sm text-gdc-gray-900 leading-4 hover:cursor-pointer">
                        {{ attribute.name }}
                    </label>
                </li>
            </ul>
        </template>
    </Accordion>
</template>

<script type="text/javascript">

import Accordion from "../../Layout/Accordion"

export default
{
    name: "FilterGroup",


    components: {
        Accordion
    },

    /**
     * Component Props
     */
    props: {
        filter: {
            type: Object
        }
    },

    methods: {

        /**
         * Toggle Filter that is not disabled!
         *
         * @param attribute
         */
        toggleFilter(attribute)
        {
            if (!attribute.is_disabled)
            {
                attribute.is_active = !attribute.is_active;
            }

            this.$emit('filtersListenerEvent');
        },
    }
}
</script>
